import {
    FETCH_MTOKNA_CAMPAIGNS,
    CLEAN_MTOKNA_CAMPAIGNS,
    DELETE_MTOKNA_CAMPAIGN,
} from '../actions/types';

const MTOKNA_CAMPAIGNS_DEFAULT_STATE = {};

const MtoknaCampaignsReducer = (state = MTOKNA_CAMPAIGNS_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_MTOKNA_CAMPAIGNS:
            return payload;

        case CLEAN_MTOKNA_CAMPAIGNS:
        case DELETE_MTOKNA_CAMPAIGN:
            return MTOKNA_CAMPAIGNS_DEFAULT_STATE;

        default:
            return state;
    }
};

export default MtoknaCampaignsReducer;
